import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-bold font-georgian text-lg md:text-2xl leading-normal text-green md:max-w-[218px] mb-7" }
const _hoisted_2 = { class: "text-2xl leading-normal text-primary-gray md:mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs leading-none" }, " sq/ft", -1)
const _hoisted_4 = { class: "text-sm md:leading-normal leading-loose lg:leading-loose text-primary-gray" }
const _hoisted_5 = { class: "grid grid-cols-2 mt-auto" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-primary-gray uppercase text-light-green font-bold md:font-normal" }, " Pile height: ", -1)
const _hoisted_8 = { class: "text-2xl text-green" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-primary-gray uppercase text-light-green font-bold md:font-normal" }, " Face Weight: ", -1)
const _hoisted_11 = { class: "text-2xl text-green" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'solution-card',
  props: ["size"],
  setup(__props) {

const props = __props;
const size = computed(() => {
  return props?.size || "md";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-auto w-4/5 bg-[#f5faf0] px-5 md:px-8 py-8 md:py-10 md:shadow-[8px_24px_34px_0_#a5a3a333] flex flex-col gap-5 md:gap-0", {
      'md:h-[642px] md:w-60 lg:w-72': size.value === 'md',
      'md:h-[520px] md:w-64 lg:w-80 xl:w-96': size.value === 'sm',
      'md:h-[428px] md:w-80 lg:w-96': size.value === 'xs',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "price"),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "height")
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "weight")
        ])
      ])
    ])
  ], 2))
}
}

})